import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getEmailConfirmationLinkExpiredPath = () => urlHelper('/email-confirmation/link-expired');
